import { render, staticRenderFns } from "./numberingScoreTable.vue?vue&type=template&id=42545586&scoped=true"
import script from "./numberingScoreTable.vue?vue&type=script&lang=js"
export * from "./numberingScoreTable.vue?vue&type=script&lang=js"
import style0 from "./numberingScoreTable.vue?vue&type=style&index=0&id=42545586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42545586",
  null
  
)

export default component.exports